/* Spans the viewport and centers the bar, so the bar can use the full width
   before it wraps – a `left: 50%` box shrinks to fit half the viewport. The
   empty sides let clicks through to the page. */
:host {
	position: fixed;
	right: 0;
	bottom: calc(24px + env(safe-area-inset-bottom, 0px));
	left: 0;
	z-index: 2147483647;
	display: flex;
	justify-content: center;
	padding: 0 16px;
	font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
	pointer-events: none;
}

:host([hidden]) {
	display: none;
}

.bar {
	display: inline-flex;
	flex-wrap: wrap;
	gap: 12px;
	align-items: center;
	justify-content: center;
	padding: 10px 10px 10px 18px;
	color: #fff;
	pointer-events: auto;
	background: rgb(20 20 24 / 92%);
	border-radius: 28px;
	box-shadow: 0 8px 24px rgb(0 0 0 / 24%);
	backdrop-filter: blur(8px);
}

.hint {
	font-size: 13px;
	color: rgb(255 255 255 / 72%);
}

.take {
	display: inline-flex;
	gap: 8px;
	align-items: center;
	padding: 12px 20px;
	font-family: inherit;
	font-size: 15px;
	font-weight: 600;
	color: #fff;
	cursor: pointer;
	background: #7c3aed;
	border: 0;
	border-radius: 20px;
}

.take:hover {
	background: #6d28d9;
}

.take:disabled {
	cursor: progress;
	opacity: 0.7;
}

.take svg {
	width: 18px;
	height: 18px;
}

.cancel {
	padding: 10px 14px;
	font-family: inherit;
	font-size: 13px;
	font-weight: 500;
	color: #fff;
	cursor: pointer;
	background: rgb(255 255 255 / 12%);
	border: 0;
	border-radius: 18px;
}

.cancel:hover {
	background: rgb(255 255 255 / 20%);
}

.take:focus-visible,
.cancel:focus-visible {
	outline: 2px solid #fff;
	outline-offset: 2px;
}
